














































































































































































































































































































import { consent } from "@/services/security/authService";
import { Component, Vue } from "vue-property-decorator";
import { bus } from "@/bus";

@Component
export default class ConsentLayout extends Vue {
    locale = this.$root.$i18n.locale;

    mounted() {
        this.$bvModal.show("modal-consent");
    }

    confirm() {
        consent().then(() => {
            bus.$emit("consentLayout", true);
        });
    }
}
